import React, { MouseEventHandler, ReactNode } from 'react'

import { Alert } from 'antd'

import './AlertStyles.less'

const classNameMappingForEachType = new Map<string, string>([
  ['error', 'alert_error'],
  ['success', 'alert_success'],
  ['info', 'alert_info'],
  ['warning', 'alert_warning'],
])

interface AlertProps {
  message: ReactNode
  type: 'success' | 'info' | 'warning' | 'error'
  closable?: boolean
  closeText?: ReactNode
  description?: ReactNode
  onClose?: MouseEventHandler<HTMLButtonElement>
  showIcon?: boolean
  banner?: boolean
  icon?: ReactNode
  className?: string
  action?: React.ReactNode
}

const Feedback = (props: AlertProps) => {
  const className = `${props.className} t-feedback ${classNameMappingForEachType.get(props.type)}`
  return <Alert {...props} className={className}></Alert>
}

export default Feedback
